<app-image-form-field
  [image]="image"
  (imageChange)="imageChange.emit($event)"
  [basePath]="'itineraries/' + itineraryId + '/images'"
  [label]="label"
  [disabled]="disabled"
></app-image-form-field>
